import {types} from 'mobx-state-tree';
import NormalizedMessageModel, {
  NormalizedMessageViews
} from '../shared/normalizedMessageModel';

export type CachedMessageOwnViews = {
  createdAt: number;
};

export type CachedMessageViews = NormalizedMessageViews &
  CachedMessageOwnViews;

const CachedMessageModel = types
  .compose(
    types.model({
      id: types.number,
      cid: types.undefined,
      createdAtInMs: types.union(types.string, types.number)
    }),
    NormalizedMessageModel
  )
  .views<CachedMessageOwnViews>(self => {
    return {
      get createdAt() {
        return Number(self.createdAtInMs);
      }
    };
  });

export type CachedMessage = typeof CachedMessageModel.Type;

export default CachedMessageModel;



// WEBPACK FOOTER //
// ./src/models/chatChannelModel/message/branches/cachedMessageModel.ts